import { isSameDay } from 'date-fns'
import { sortBy } from 'lodash'
import { createSelector } from 'reselect'
import { IStore } from '../../index'

export function getSelectedColumns(state: IStore): Date[] {
  return state.bookingCalendar.selectedColumns
}

export const getSortedSelectedColumns = createSelector(
  [getSelectedColumns],
  dates => sortBy(dates, b => b.getTime()),
)

export const getSelectedColumnsAsNumber = createSelector(
  [getSelectedColumns, (_, props) => props.days],
  (dates, dateRange) =>
    dates.map(date => dateRange.findIndex(d => isSameDay(d, date))),
)
